import { API_DEPRECATED } from 'api/apiDeprecated';
import { API_UNPROTECTED } from 'api/apiUnprotected';
import { AxiosResponse } from 'axios';
import { AffordabilityEvaluationDto } from 'pages/CalculatorPage/types';
import { AffordabilityDto, AffordabilityEvaluationResponse, AffordabilityResponse } from './types';
import { ServerError } from '../../errors/server-error';
import { config } from 'utils/config';

export const affordabilityProxyApi = {
  getAffordabilityEvaluation: async (
    formDataDto: AffordabilityEvaluationDto,
  ): Promise<AffordabilityEvaluationResponse[]> => {
    try {
      const response = await API_UNPROTECTED.post<
        AffordabilityEvaluationDto,
        AxiosResponse<AffordabilityEvaluationResponse[]>
      >('/affordabilityProxy/evaluate', formDataDto, { headers: { 'Content-Type': 'application/json' } });

      return response.data;
    } catch (err: any) {
      const { message = 'Internal Server Error' } = err.response.data || err.response.statusText;
      const { status = 500 } = err.response;

      throw new ServerError(status, message);
    }
  },
  getAffordability: async (formDataDto: AffordabilityDto): Promise<AffordabilityResponse> => {
    try {
      const apiKey = config.env.VITE_LEGACY_AFFORDABILITY_API_KEY || '';
      const response = await API_DEPRECATED.post<AffordabilityDto, AxiosResponse<AffordabilityResponse>>(
        '/affordabilityRuns/applications/id',
        formDataDto,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': apiKey,
          },
        },
      );

      return response.data;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
};
